import { Component, EventEmitter, Input, Output, DoCheck, OnChanges } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';

@Component({
  selector: 'edit-ready-to-complete',
  styles: [require('../../../direct-connect.scss')],
  template: require('./edit-rtoc.html'),
    providers: [
      TranslateService
  ]
})
export class EditReadyToComplete {
  @Input() stepData: Object;
  @Input() edgeName: string;
  private orgList: JSON;
  private isTranslationready: boolean = true;

  constructor(private translate: TranslateService) {
      translate.use(GlobalVariables.LOCALE);
  }

  ngOnChanges(changes) {
  }

  getIPRanges() {
    if (this.stepData && this.stepData[0]) {
        let arrIPRanges = this.stepData[0].ipRanges.map(function(item){
            return item.startAddress + ' - ' + item.endAddress;
        });
        return arrIPRanges.join(', ');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/wizards/edit-gateway/steps/edit-rtoc.component.ts